module.exports = __webpack_public_path__ + "media/reskin-images/icon--play-circle-5aa3c483.svg";